var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('v-btn',{staticClass:"mapCardWrap",attrs:{"color":"accent","block":"","large":"","loading":_vm.busy},on:{"click":function($event){return _vm.vuexBetriebe(_vm.leistung.gewerk.defaultleistung_id)}}},[_vm._v("Ausweiten auf "+_vm._s(_vm.leistung.gewerk.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }